'use client';

import { useUserSession } from '@libs/common-next';

import { CarouselContent } from './carousel-content';

type BuyItAgainProps = {
    readonly header: string;
    readonly subheader?: string;
};

export function BuyItAgain({ header, subheader }: BuyItAgainProps) {
    const { isAuthenticated, isSoftAuthenticated } = useUserSession();

    if (!isAuthenticated || isSoftAuthenticated) {
        return null;
    }

    return <CarouselContent header={header} subheader={subheader} />;
}
